import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Box, IconButton, Toolbar, SvgIcon } from '@mui/material';
import { Menu as MenuIcon } from 'react-feather';
import Notifications from './Notifications';
import Search from './Search';
import Settings from './Settings';
import useCustomStyles from 'src/hooks/useCustomStyles';
import Profile from './Profile';
import { Theme } from '@mui/material/styles';
import { Logo } from 'src/components/logo';

const styles = (theme: Theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
  },
  toolbar: {
    minHeight: 64,
  },
  menuButton: {
    marginRight: '10px',
  },
});

interface Props {
  onNavOpen: () => void;
}

const TopBar: React.FC<Props> = ({ onNavOpen }) => {
  const classes = useCustomStyles(styles);

  return (
    <AppBar className={classes.root}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          className={classes.menuButton}
          color="inherit"
          onClick={onNavOpen}
          size="large">
          <SvgIcon fontSize="small">
            <MenuIcon />
          </SvgIcon>
        </IconButton>
        <RouterLink to={`/`}>
          <Logo />
        </RouterLink>
        <Box ml={2} flexGrow={1} />
        {/*<Search />*/}
        <Notifications />
        <Settings />
        <Box
        //ml={2}
        >
          <Profile />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopBar;
